import Vue from 'vue'
import index from './index.vue'
import '../base/common'

new Vue({
  data() {
    return {
      state: {
        brandInfo:{},
        isShowContact:false
      }
    }
  },
  created() {
    Vue.prototype.$state = this.state
  },
  render: h => h(index)
}).$mount('#app')
